"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_generatedFundingRequest = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const requiredFundingSubmissionComponentsArtifactFields = {
    targetFundingDate: 'targetFundingDate',
    totalAmount: 'totalAmount',
    type: 'type',
};
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, creditFacilitySlug, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Funding Request`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            description: 'a note for funding request node',
            creditFacilitySlug,
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = (0, utils_1.updateArtifactSlug)(nodeData.configuration.artifactSlug, suggestedSerialNumber);
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_generatedBorrowingBaseReport',
        'operation_verify',
        'file_directInsertBorrowingBaseReport',
        'file_intermediateTape',
        'file_dataLakeTape',
        'file_waitForDataLakeTable',
    ];
    const errors = (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: (uiNode) => allowedInputNodes.includes(uiNode.nodeType),
        getUINode,
        minInputs: 1,
        maxInputs: 100,
        minOutputs: 0,
        maxOutputs: 0,
    });
    return errors;
};
const validateIntermediateTape = ({ tape, graph, tapeBuilder, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'fundingRequest', `node is not a fundingRequest, found: [tape.type:${tape.type}]`);
    const { id, artifactSlug, configuration } = tape;
    const artifactInputs = (0, utils_1.getDirectInputsForArtifact)({
        targetArtifactId: id,
        ...graph,
    });
    const { fundingSubmissionComponentsArtifactSlug } = configuration;
    const configErrors = [];
    // mutates local configErrors
    const validateFields = ({ artifactSlugToValidate, requiredFields, }) => {
        const artifactInput = artifactInputs.find((input) => input.artifactSlug === artifactSlugToValidate);
        if (!artifactInput) {
            configErrors.push(`fundingRequest: [${artifactSlug}] cannot find [inputArtifact:${artifactSlugToValidate}] listed as an input dependency.`);
            return;
        }
        const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(artifactInput.id);
        if (!tapeDefinitionResult.isValid || !tapeDefinitionResult.data) {
            configErrors.push(`fundingRequest: [${artifactSlug}] cannot get tape definition of [inputArtifact:${artifactSlugToValidate}].`);
            return;
        }
        const baseFields = tapeDefinitionResult.data.baseFields;
        requiredFields.forEach((field) => {
            const foundField = baseFields.filter((baseField) => baseField.field === field);
            if (foundField.length !== 1) {
                configErrors.push(`fundingRequest: [${artifactSlug}] [inputArtifact:${artifactSlugToValidate}] tape definition is missing [field:${field}].`);
            }
        });
    };
    if (fundingSubmissionComponentsArtifactSlug) {
        validateFields({
            artifactSlugToValidate: fundingSubmissionComponentsArtifactSlug,
            requiredFields: Object.keys(requiredFundingSubmissionComponentsArtifactFields),
        });
    }
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_generatedFundingRequest = {
    // what should node say on the tape-buider node creation menu.
    nodeTypeText: 'Funding Request',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: true,
    // operatin nodes dont render badges.
    badgeTexts: ['FundingRequest'],
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map